import { getAirbrake } from "@simplybusiness/services";
import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import {
  AIRBRAKE_PROJECT_ID,
  AIRBRAKE_PROJECT_KEY,
} from "../../constants/constants";
import { GenericError } from "./GenericError";
import "./ErrorBoundary.css";

export interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ hasError: true });

    const airbrake = getAirbrake({
      projectId: AIRBRAKE_PROJECT_ID,
      projectKey: AIRBRAKE_PROJECT_KEY,
    });

    void airbrake.notify({
      error,
      params: { info },
    });
  }

  render() {
    const { hasError } = this.state;

    const { children } = this.props;

    if (hasError) {
      return <GenericError />;
    }

    return children;
  }
}
